import React, { useState, useRef, useEffect } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import FunnelModule from "highcharts/modules/funnel";
import EmptyRows from "../../../components/reusableComponent/EmptyRows";
import Highcharts3d from "highcharts/highcharts-3d.js";
import Cylinder from "highcharts/modules/cylinder.js"
import Funnel from "highcharts/modules/funnel.js"
// Initialize Funnel module
Highcharts3d(Highcharts);
Cylinder(Highcharts);
Funnel(Highcharts);

// Lead funnel palette: reference-style (dark purple-blue, gray-blue, magenta, teal) + extended, no repeat for large data
const FUNNEL_COLORS = [
  "#4a45a3", "#6a7796", "#7b8ab8", "#c751c7", "#28c0a8",
  "#6366f1", "#8b5cf6", "#a855f7", "#d946ef", "#ec4899", "#f43f5e", "#f97316", "#eab308", "#84cc16", "#22c55e",
  "#14b8a6", "#06b6d4", "#6366f1", "#6366f1", "#64748b", "#475569", "#78716c", "#a16207", "#15803d", "#0f766e",
];
function getFunnelStageColor(index: number): string {
  if (index < FUNNEL_COLORS.length) return FUNNEL_COLORS[index];
  const hue = (index * 37) % 360;
  return `hsl(${hue}, 55%, 48%)`;
}

interface FunnelData {
  funnel_stage: string;
  stage_order: number;
  lead_count: number;
  status_type?: string;
}

interface ConversionFunnelProps {
  data: FunnelData[];
  title?: string;
  height?: number | string;
  width?: number | string;
  /** When user clicks a stage (e.g. legend), call with stage name and status_type for click-to-expand. */
  onStageClick?: (stageName: string, statusType?: string) => void;
}


const ConversionFunnel: React.FC<ConversionFunnelProps> = ({
  data = [],
  title = 'Conversion Funnel',
  height = 500,
  width = '100%',
  onStageClick,
}) => {
  const onStageClickRef = useRef(onStageClick);
  useEffect(() => {
    onStageClickRef.current = onStageClick;
  }, [onStageClick]);

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "funnel3d",
      options3d: {
        enabled: true,
        alpha: 10,
        depth: 50,
        viewDistance: 50
      }
    },
    title: { text: "" },
    credits: { enabled: false },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'vertical',
      x: 0,
      y: 20,
      itemStyle: {
        cursor: "pointer"
      },
      useHTML: true
    },
    plotOptions: {
      series: {
        cursor: "pointer",
        point: {
          events: {
            click: function (this: any) {
              const stageName = this.name;
              const statusType = this.options?.status_type;
              onStageClickRef.current?.(stageName, statusType);
            },
          },
        },
        dataLabels: {
          enabled: true,
          align: 'center',
          verticalAlign: "bottom",
          y: 30,  // Adjust Y-position to avoid overlap
          format: '{point.y}',
          style: {
            fontSize: "14px",
            color: "white",
            textOutline: "none",  // This removes the black outline

          }
        },

        neckWidth: "30%",
        neckHeight: "25%",
        width: "70%",
        height: "70%"
      }
    },
    series: [{
      name: "Lead stages",
      data: []
    }]
  });


  React.useEffect(() => {
    if (data && data.length > 0) {
      const formattedData = data.map((item, index) => ({
        name: item.funnel_stage,
        y: item.lead_count,
        color: getFunnelStageColor(index),
        status_type: item.status_type,
      }));

      setChartOptions(prev => ({
        ...prev,
        series: [{
          ...prev.series[0],
          data: formattedData
        }]
      }));
    }
  }, [data]);


  console.log(data, "data ")
  const noDataPresent = !data || data.length === 0;
  const handleLegendClick = (name) => {
    setChartOptions((prev) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: prev.series[0].data.map((item) => ({
            ...item,
            sliced: item.name === name ? !item.sliced : false, // Highlight clicked item
            selected: item.name === name ? !item.selected : false,
          })),
        },
      ],
    }));
    const selectedDataPoint = chartOptions.series[0].data.find((item) => item.name === name);

    if (selectedDataPoint) {

    }
  };


  return (


    <>

      <div className="row align-items-center mx-0 w-100">
        {noDataPresent ? (
          <div className="mixed-chart" style={{ height: "420px", width: "100%" }}>
            <EmptyRows value="" />
          </div>
        ) : (
          <>

            <div className="row align-items-center mx-0 w-100">

              <div>
                <HighchartsReact highcharts={Highcharts} options={chartOptions} />
              </div>
            </div>
            <div
              className="custom-legend justify-content-center"
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px 20px",
                paddingTop: "16px",
                marginTop: "12px",
                paddingLeft: "8px",
                paddingRight: "8px",
                paddingBottom: "4px",
                maxWidth: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                justifyContent: "center",
                alignItems: "center",
                borderTop: "1px solid #e2e8f0",
              }}
            >
              {chartOptions.series[0].data.map((item, index) => (
                <div
                  key={`legend-${index}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    backgroundColor: item.selected ? "rgba(0, 0, 0, 0.05)" : "transparent",
                    transition: "background-color 0.2s ease",
                    flex: "0 0 auto"
                  }}
                  onClick={() => {
                    handleLegendClick(item.name);
                    onStageClick?.(item.name, item.status_type);
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.05)";
                  }}
                  onMouseOut={(e) => {
                    if (!item.selected) {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: item.color,
                      marginRight: "8px",
                      borderRadius: "2px",
                      flexShrink: 0
                    }}
                  />
                  <span
                    style={{
                      color: "rgb(55, 61, 63)",
                      fontSize: "12px",
                      fontWeight: item.selected ? 600 : 400,
                      fontFamily: "Helvetica, Arial, sans-serif",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "120px"
                    }}
                    title={item.name}
                  >
                    {item.name}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>


    </>
  );
};

export default ConversionFunnel;